export class FCMMessageRegistration {
  locId: number;
  locCusId: string;
  deviceId: string = "";
  token: string = "";
  deviceType: string = "Web";
  applicationName:string="CUI"
}